__webpack_require__.p = "/hindi-typing/_next/";